import { render, staticRenderFns } from "./page-products-id-section-menu.vue?vue&type=template&id=c819f21c&"
import script from "./page-products-id-section-menu.vue?vue&type=script&lang=ts&"
export * from "./page-products-id-section-menu.vue?vue&type=script&lang=ts&"
import style0 from "./page-products-id-section-menu.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "../../../../assets/scss/grid.scss?vue&type=style&index=1&module=styleGrid&lang=scss&"
import style2 from "../../../../assets/scss/spacer.scss?vue&type=style&index=2&module=styleSpacer&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)
this["styleGrid"] = (style1.locals || style1)
this["styleSpacer"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports